export enum RESPONSE_STATUS_DESC {
	DESC = 'CAMPAIGN_NAME_ALREADY_PRESENT_FOR_BOT',
}
